export default {
  appId: "",
};
